function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.841156,
  width: 64.5882,
  height: 60,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1554_1276)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.2242 51.6875C49.9551 51.6875 49.7084 51.6458 49.4842 51.5625C49.2599 51.4792 49.0356 51.3333 48.8114 51.125L35.49 38.8125C35.2658 38.6042 35.1088 38.3958 35.0191 38.1875C34.9294 37.9792 34.8845 37.75 34.8845 37.5C34.8845 37.25 34.9294 37.0208 35.0191 36.8125C35.1088 36.6042 35.2658 36.3958 35.49 36.1875L39.5941 32.375C39.8184 32.1667 40.0426 32.0208 40.2669 31.9375C40.4911 31.8542 40.7378 31.8125 41.007 31.8125C41.2761 31.8125 41.5228 31.8542 41.747 31.9375C41.9713 32.0208 42.1956 32.1667 42.4198 32.375L55.7411 44.75C55.9654 44.9583 56.1224 45.1667 56.2121 45.375C56.3018 45.5833 56.3467 45.8125 56.3467 46.0625C56.3467 46.3125 56.3018 46.5417 56.2121 46.75C56.1224 46.9583 55.9654 47.1667 55.7411 47.375L51.6371 51.125C51.4128 51.3333 51.1886 51.4792 50.9643 51.5625C50.74 51.6458 50.4933 51.6875 50.2242 51.6875ZM50.2242 50.0625L54.5301 46.0625L41.007 33.5L36.7011 37.5L50.2242 50.0625ZM15.979 51.6875C15.7099 51.6875 15.4632 51.6458 15.2389 51.5625C15.0147 51.4792 14.7904 51.3333 14.5662 51.125L10.4621 47.375C10.2378 47.1667 10.0809 46.9583 9.99116 46.75C9.90145 46.5417 9.8566 46.3125 9.8566 46.0625C9.8566 45.8125 9.90145 45.5729 9.99116 45.3438C10.0809 45.1146 10.2378 44.8958 10.4621 44.6875L24.1871 31.9375H29.7713L31.7897 30.0625L20.2849 19.375H16.45L10.0584 13.4375L15.2389 8.625L21.6305 14.5625V18.125L33.1353 28.8125L41.3433 21.1875L35.7592 16L38.5849 13.375H32.9334L32.0588 12.625L39.1231 6.0625L39.9305 6.8125V12.125L42.7562 9.5L53.79 19.625C54.418 20.1667 54.8777 20.7917 55.1693 21.5C55.4608 22.2083 55.6066 22.9583 55.6066 23.75C55.6066 24.25 55.5393 24.7396 55.4047 25.2188C55.2702 25.6979 55.0683 26.1667 54.7992 26.625L49.3496 21.5625L45.5147 25.125L42.6217 22.4375L31.0496 33.1875V38.5L17.3919 51.125C17.1676 51.3333 16.9434 51.4792 16.7191 51.5625C16.4948 51.6458 16.2481 51.6875 15.979 51.6875ZM15.979 50L29.7713 37.1875V33.1875H25.4654L11.6731 46L15.979 50Z",
  fill: "white"
}));

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 60,
    viewBox: "0 0 66 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1554_1276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 66,
    height: 60
  }, _ref2), _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.d029e6ab.svg";
export { ForwardRef as ReactComponent };